import { Button, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import type { TComponent } from 'utils/types/component';

import styles from './InvoicesExportModal.module.scss';

interface IInvoicesExportModalProps {
    onSave: (email: string) => void;
    onClose: () => void;
}

export const InvoicesExportModal: TComponent<IInvoicesExportModalProps> = (
    props,
) => {
    const { onClose, onSave } = props;

    const { t } = useTranslation();

    const [form] = Form.useForm();

    const handleSend = async () => {
        try {
            await form.validateFields();
            onSave(form.getFieldValue('email'));
            onClose();
        } catch {}
    };

    return (
        <Modal
            open
            onCancel={onClose}
            footer={[
                <Button
                    className={styles.sendBtn}
                    onClick={handleSend}
                    key='send'
                    type='primary'
                >
                    {t('common.buttons.send')}
                </Button>,
            ]}
            title={t('invoices.payment.export.title')}
        >
            <Form form={form} layout='vertical'>
                <Form.Item
                    name='email'
                    label={t('common.form.enterEmail')}
                    rules={[
                        {
                            required: true,
                            message: t('common.form_error.email_required'),
                        },
                        {
                            type: 'email',
                            message: t('common.form_error.email_wrong'),
                        },
                    ]}
                >
                    <Input placeholder='example@test.com' />
                </Form.Item>
            </Form>
        </Modal>
    );
};
